<template>
  <div
    class="modal bg-[rgba(0, 0, 0, 1)] fade py-1 z-[111111111]"
    id="mod-update-order-caution"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-[32px] bg-[#f8f8f8]">
        <div class="modal-body m-0 p-0">
          <p class="text-[14px] leading-[20px] font-normal text-[#353535]">
            You're about to update order with order number:
            {{ orderNumber }}
          </p>
        </div>
        <div class="flex items-center gap-[8px] mt-[24px]">
          <button
            class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
          >
            No, Cancel
          </button>
          <button
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            @click.prevent="onSubmitClick"
          >
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdateOrderCaution",
  props: ["orderNumber", "closeModal"],

  data() {
    return {
      isDisabled: false,
    };
  },

  created() {
    this.orderId = this.$route.params.id;
  },

  methods: {
    async onSubmitClick() {
      this.$emit("onProceedClick");
    },
  },
};
</script>

<style></style>
